import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import { Button, ButtonProps } from '@teuteuf-games/button';
import { useTranslation } from 'react-i18next';

export const getGuessButtonProps = (
  label: ButtonProps['label'],
  onClick?: ButtonProps['onClick'],
  disabled?: ButtonProps['disabled'],
  buttonStyle?: ButtonProps['buttonStyle'],
  extraClasses?: ButtonProps['extraClasses'],
): ButtonProps => {
  return {
    buttonStyle: buttonStyle ?? 'primary-gradient',
    type: 'submit',
    onClick,
    disabled,
    leadingIcon: <PublicRoundedIcon />,
    label,
    extraClasses,
  };
};

export const GuessButton = ({
  onClick,
  disabled,
  buttonStyle,
}: {
  onClick: ButtonProps['onClick'];
  disabled?: ButtonProps['disabled'];
  buttonStyle?: ButtonProps['buttonStyle'];
}) => {
  const { t } = useTranslation();

  return (
    <Button
      {...getGuessButtonProps(t('guess'), onClick, disabled, buttonStyle)}
    />
  );
};
